import moment from 'moment';
import { List, Map, fromJS } from 'immutable';
import * as constAction from 'root/actionConstants';
import { listFindByMapId, listFindById, calcularDistanciaEnPoly } from 'core/generalFunctions';

const defaultState = Map({
  viaje: Map(),
  hoy: List(),
  manana: List(),
  buscado: List(),
  paradas: List(),
  reservas: List(),
  diaBuscando: false,
  eliminarId: false,
  puntosDelTrayecto: [],
});

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case constAction.VIAJES_CLEAR: {
      if (action.payload === 'all') return defaultState;
      else if (defaultState.has(action.payload)) return state.set(action.payload, defaultState.get(action.payload));
      else {
        console.error('No existe la propiedad ' + action.payload);
        return state;
      }
    }
    case constAction.VIAJES_SET_STATE: {
      let newState = state;
      for (var key in action.payload) {
        newState = newState.set(key, fromJS(action.payload[key]));
      }
      return newState;
    }
    case constAction.VIAJES_CONCAT_STATE: {
      const { stateName, data } = action.payload;
      return state.set(stateName, state.get(stateName).push(fromJS(data)));
    }
    case constAction.VIAJES_FINDUPD_STATE: {
      const { id, stateName, data } = action.payload;
      const index = listFindById(state.get(stateName), id, true);
      fromJS(data).map((data, key) => {
        state = state.setIn([stateName, index, key], fromJS(data));
      });
      return state;
    }
    case constAction.VIAJES_SET_STATE_BUSCAR: {
      return state.set('buscado', fromJS(action.payload));
    }
    case constAction.VIAJES_SET_STATE_BY_ID: {
      return state.set('viaje', fromJS(action.payload));
    }
    case constAction.VIAJES_SOCKET_DATA: {
      const {
        payload,
        payload: { documentKey, operationType },
      } = action;

      if (operationType == 'insert') {
        const day = moment(payload.fullDocument.horario).isSame(moment(), 'day') ? 'hoy' : moment(payload.fullDocument.horario).isSame(moment().add(1, 'day'), 'day') ? 'manana' : null;
        if (!day) return state;
        let viajeRecibido = Map(payload.fullDocument).set('id', documentKey._id);
        if (viajeRecibido.get('_id')) viajeRecibido.delete('_id');
        state = state.set(
          day,
          state
            .get(day)
            .push(viajeRecibido)
            .sortBy(viaje => viaje.get('horario')),
        );
      } else {
        let listName = 'hoy',
          index = listFindByMapId(state.get(listName), documentKey._id, true);
        if (index == -1) {
          listName = 'manana';
          index = listFindByMapId(state.get(listName), documentKey._id, true);
          if (index == -1) {
            listName = 'buscado';
            index = listFindByMapId(state.get(listName), documentKey._id, true);
          }
        }
        if (operationType == 'delete') state = state.deleteIn([listName, index]);
        else {
          let updatedFields, removedFields;
          if (action.payload.updateDescription) {
            updatedFields = Map(action.payload.updateDescription.updatedFields);
            removedFields = Map(action.payload.updateDescription.removedFields);
          } else {
            updatedFields = Map();
            removedFields = Map();
          }
          updatedFields.map((value, key) => {
            state = state.setIn([listName, index, key], value);
          });
          removedFields.map((value, key) => {
            state = state.deleteIn([listName, index, key]);
          });
        }
      }

      return state;
    }
    case constAction.VIAJES_RESET_VIAJE: {
      return state.set('viaje', Map());
    }
    case constAction.VIAJES_RESET_DAY: {
      return state.set(action.payload, List());
    }
    case constAction.VIAJES_PASAJEROS_ORDER: {
      let pasajerosOrdenados = List(),
        pasajeros = fromJS(action.payload),
        activos = pasajeros.filter(pasajero => !pasajero.get('cancelada')),
        cancelados = pasajeros.filter(pasajero => pasajero.get('cancelada'));
      if (pasajeros.size > 0) {
        pasajeros = activos.groupBy(pasajero => pasajero.get('_paradaSubida') && pasajero.getIn(['_paradaSubida', 'id']));
        pasajeros = pasajeros.map(grupo => {
          const distanciaParada = calcularDistanciaEnPoly(
            state.getIn(['viaje', '_trayecto', 'polyline']),
            {
              latitude: grupo.getIn([0, '_paradaSubida', 'localizacion', 'lat']),
              longitude: grupo.getIn([0, '_paradaSubida', 'localizacion', 'lng']),
            },
            true,
          );
          return grupo.map(itm => itm.set('distancia', distanciaParada));
        });
        pasajeros = pasajeros.sortBy(grupo => grupo.getIn([0, 'distancia']));
        pasajeros.map(grupo => (pasajerosOrdenados = pasajerosOrdenados.concat(grupo)));
        pasajerosOrdenados = pasajerosOrdenados.concat(cancelados);
      }
      return state.set('reservas', pasajerosOrdenados);
    }
    case constAction.VIAJES_SET_TRAYECTO: {
      return state.setIn(['viaje', 'trayecto'], fromJS(action.payload));
    }
    case constAction.VIAJESLOC_SOCKET_DATA: {
      const { payload } = action;
      if (!payload.viajeId) return state;
      let ubicacion = {};
      if (payload.ubicacion.lat && payload.ubicacion.lng) ubicacion = payload.ubicacion;
      else if (payload.ubicacion.coordinates) ubicacion = { lat: payload.ubicacion.coordinates[1], lng: payload.ubicacion.coordinates[0] };
      else if (payload.ubicacion && payload.ubicacion.lenght > 0) ubicacion = { lat: payload.ubicacion[1], lng: payload.ubicacion[0] };
      else return state;

      const index = listFindByMapId(state.get('hoy'), payload.viajeId, true),
        newLoc = fromJS({
          fechaEnviado: payload.fechaEnviado,
          ubicacion,
          exactitud: payload.exactitud,
          velocidad: payload.velocidad,
        });
      if (state.getIn(['viaje', 'id']) == payload.viajeId) state = state.setIn(['viaje', '_localizacion', 0], newLoc);
      if (index !== -1) state = state.setIn(['hoy', index, '_localizacion', 0], newLoc);
      return state;
    }
    case constAction.VIAJES_SET_GRUPOS: {
      let newGrupos = state.getIn(['viaje', 'grupos']) || List();
      const index = newGrupos.findIndex(grupoId => grupoId == action.payload.grupoId);
      if (index === -1 && action.payload.agregar) {
        newGrupos = newGrupos.push(action.payload.grupoId);
        return state.setIn(['viaje', 'grupos'], newGrupos);
      } else if (index !== -1 && !action.payload.agregar) {
        return state.deleteIn(['viaje', 'grupos', index]);
      } else return state;
    }
    default:
      return state;
  }
}

const getDistance = (p1, p2) => {
  let a = p1.x - p2.x,
    b = p1.y - p2.y;
  return Math.sqrt(a * a + b * b);
};



// WEBPACK FOOTER //
// src/modules/viajes/reducer.js